import { useSearchParams } from "react-router-dom";
import LOCAL_TABLE_CONFIG_KEY from "../types/TableLocalConfigKeys";
import { useEffect } from "react";
import { useAppDispatch } from "./storeHooks";
import {
    defaultDefectsFiltersConfig,
    defaultSharedDefectsFiltersConfig
} from "../components/DefectsTable/Filters/FilterTemplates";
import { DefectTableFields } from "../components/DefectsTable/DefectTableFields";
import { resetTableFilters } from "../store/thunks/filtersThunks";
import { setActiveTab } from "../store/slices/defectSlice";
import { DefectTabs } from "../types/DefectTabs";
import { useTranslation } from "react-i18next";
import { FilterMatchMode } from "primereact/api";
import { DefectStatus } from "../types/DefectStatus";
import { setSharedDefectsTableFilterData } from "../store/slices/filtersSlice";
import { SharedDefectTableFields } from "../components/DefectsTable/SharedDefectTableFields";

export const useTableSearchParams = (tableKey: string, loading: boolean) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!loading) {
            if (tableKey === LOCAL_TABLE_CONFIG_KEY.DEFECTS) {
                const statusParam = searchParams.get("status")
                    ? Number(searchParams.get("status"))
                    : null;
                const evidenceParam = searchParams.get("evidence");

                if (statusParam !== null || evidenceParam) {
                    const filters = { ...defaultDefectsFiltersConfig };

                    if (statusParam !== null) {
                        filters[DefectTableFields.STATUS] = {
                            value: [statusParam],
                            matchMode: FilterMatchMode.IN
                        };
                    }

                    if (
                        evidenceParam === t("defectsTable.notProvided") &&
                        statusParam === DefectStatus.rectified
                    ) {
                        filters[DefectTableFields.EVIDENCE] = {
                            value: [evidenceParam],
                            matchMode: FilterMatchMode.IN
                        } as any;
                    }

                    dispatch(
                        resetTableFilters(LOCAL_TABLE_CONFIG_KEY.DEFECTS, filters)
                    );
                    dispatch(setActiveTab(DefectTabs.defects));
                }
            }

            if (tableKey === "shared-defects-table") {
                const statusParam = searchParams.get("status")
                    ? Number(searchParams.get("status"))
                    : null;
                const evidenceParam = searchParams.get("evidence");

                if (statusParam !== null || evidenceParam) {
                    const filters = { ...defaultSharedDefectsFiltersConfig };

                    if (statusParam !== null) {
                        filters[SharedDefectTableFields.STATUS] = {
                            value: [statusParam],
                            matchMode: FilterMatchMode.IN
                        } as any;
                    }

                    if (
                        evidenceParam === t("defectsTable.notProvided") &&
                        statusParam === DefectStatus.rectified
                    ) {
                        filters[SharedDefectTableFields.EVIDENCE] = {
                            value: [evidenceParam],
                            matchMode: FilterMatchMode.IN
                        } as any;
                    }
                    dispatch(setSharedDefectsTableFilterData(filters));
                }
            }
        }
    }, [searchParams, loading]);
};
